import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText
} from "@mui/material";

import DownloadIcon from "@mui/icons-material/Download";

export default function FileDrawer({ open, onClose, onFileSelect,files,onDownload }) {
  // const files = [{name:"test.pdf"}]; // your uploaded files

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box sx={{ width: 320, p: 2 }}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6">Files</Typography>
          
        </Box>

        <List>
          {files.map((file, i) => (
            <ListItem
              button
              key={i}
              onClick={() => onFileSelect(i)}
            >
              <ListItemText primary={file.name} />
              <IconButton size="small">
                <DownloadIcon onClick={() => onDownload(i)}/>
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
}
